import type { ReactNode } from 'react';

export function Chargement({ quoi }: { quoi: string }) {
  return <p className="attente">Chargement {quoi}…</p>;
}

export function Erreur({ message }: { message: string }) {
  return (
    <p className="erreur" role="alert">
      {message}
    </p>
  );
}

export function Vide({ enfants }: { enfants: ReactNode }) {
  return <p className="vide">{enfants}</p>;
}
